import { render } from "./SectionEmpresa.vue?vue&type=template&id=62b0e8fe&scoped=true"
import script from "./SectionEmpresa.vue?vue&type=script&lang=js"
export * from "./SectionEmpresa.vue?vue&type=script&lang=js"

import "./SectionEmpresa.vue?vue&type=style&index=0&id=62b0e8fe&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b0e8fe"]])

export default __exports__